/* tslint:disable */
/* eslint-disable */
/**
 * Abekus Open API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ATSBoardListResponse } from '../models';
// @ts-ignore
import type { ATSBoardResponse } from '../models';
// @ts-ignore
import type { ActiveJobBody } from '../models';
// @ts-ignore
import type { ActiveJobsResponse } from '../models';
// @ts-ignore
import type { AutoPostPreviewResponse } from '../models';
// @ts-ignore
import type { BackfillLocationsBody } from '../models';
// @ts-ignore
import type { BackfillLocationsResponse } from '../models';
// @ts-ignore
import type { BlockCandidateListResponse } from '../models';
// @ts-ignore
import type { BlockCompanyBody } from '../models';
// @ts-ignore
import type { BlockCompanyResponse } from '../models';
// @ts-ignore
import type { BlockedCompanyListResponse } from '../models';
// @ts-ignore
import type { BulkCreateATSBoardsBody } from '../models';
// @ts-ignore
import type { BulkCreateATSBoardsResponse } from '../models';
// @ts-ignore
import type { CatalogCountryFacetsResponse } from '../models';
// @ts-ignore
import type { CatalogListResponse } from '../models';
// @ts-ignore
import type { CensusResponse } from '../models';
// @ts-ignore
import type { ClaudeReviewListResponse } from '../models';
// @ts-ignore
import type { ClaudeReviewVerdictsBody } from '../models';
// @ts-ignore
import type { ClaudeReviewVerdictsResponse } from '../models';
// @ts-ignore
import type { CollectionIngestResponse } from '../models';
// @ts-ignore
import type { CollectionListResponse } from '../models';
// @ts-ignore
import type { CreateATSBoardBody } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { ExternalJobPreferencesResponse } from '../models';
// @ts-ignore
import type { FetchCatalogItemBody } from '../models';
// @ts-ignore
import type { FetchCatalogItemResponse } from '../models';
// @ts-ignore
import type { FetchRequestBody } from '../models';
// @ts-ignore
import type { FetchRunListResponse } from '../models';
// @ts-ignore
import type { FetchRunResponse } from '../models';
// @ts-ignore
import type { FetchTopBody } from '../models';
// @ts-ignore
import type { FetchTopResponse } from '../models';
// @ts-ignore
import type { HygieneSweepBody } from '../models';
// @ts-ignore
import type { HygieneSweepResponse } from '../models';
// @ts-ignore
import type { IngestCollectionBody } from '../models';
// @ts-ignore
import type { IngestResultResponse } from '../models';
// @ts-ignore
import type { JobsPipeCensusBody } from '../models';
// @ts-ignore
import type { JobsPipeCensusResponse } from '../models';
// @ts-ignore
import type { PreviewFetchResponse } from '../models';
// @ts-ignore
import type { ReconcileThinBody } from '../models';
// @ts-ignore
import type { ReconcileThinResponse } from '../models';
// @ts-ignore
import type { RescoreCatalogBody } from '../models';
// @ts-ignore
import type { SeedCollectionsResponse } from '../models';
// @ts-ignore
import type { SetATSBoardScoresBody } from '../models';
// @ts-ignore
import type { SetATSBoardScoresResponse } from '../models';
// @ts-ignore
import type { TargetedIngestBody } from '../models';
// @ts-ignore
import type { TargetedIngestResponse } from '../models';
// @ts-ignore
import type { UnblockCompanyResponse } from '../models';
// @ts-ignore
import type { UpdateATSBoardBody } from '../models';
// @ts-ignore
import type { UpdateExternalJobPreferenceBody } from '../models';
/**
 * ExternalJobApiApi - axios parameter creator
 */
export const ExternalJobApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ClaudeReviewVerdictsBody} claudeReviewVerdictsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalJobApiApplyClaudeReviewVerdicts: async (claudeReviewVerdictsBody: ClaudeReviewVerdictsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'claudeReviewVerdictsBody' is not null or undefined
            assertParamExists('externalJobApiApplyClaudeReviewVerdicts', 'claudeReviewVerdictsBody', claudeReviewVerdictsBody)
            const localVarPath = `/admin/external-jobs/claude-review`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(claudeReviewVerdictsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BackfillLocationsBody} backfillLocationsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalJobApiBackfillExternalJobLocationsRoute: async (backfillLocationsBody: BackfillLocationsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'backfillLocationsBody' is not null or undefined
            assertParamExists('externalJobApiBackfillExternalJobLocationsRoute', 'backfillLocationsBody', backfillLocationsBody)
            const localVarPath = `/admin/external-jobs/backfill-locations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(backfillLocationsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BlockCompanyBody} blockCompanyBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalJobApiBlockExternalCompany: async (blockCompanyBody: BlockCompanyBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'blockCompanyBody' is not null or undefined
            assertParamExists('externalJobApiBlockExternalCompany', 'blockCompanyBody', blockCompanyBody)
            const localVarPath = `/admin/external-jobs/blocked-companies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(blockCompanyBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BulkCreateATSBoardsBody} bulkCreateATSBoardsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalJobApiBulkCreateAtsBoards: async (bulkCreateATSBoardsBody: BulkCreateATSBoardsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkCreateATSBoardsBody' is not null or undefined
            assertParamExists('externalJobApiBulkCreateAtsBoards', 'bulkCreateATSBoardsBody', bulkCreateATSBoardsBody)
            const localVarPath = `/admin/ats-boards/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkCreateATSBoardsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} [includeAll] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalJobApiCensusAllAtsBoards: async (includeAll?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/ats-boards/census`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (includeAll !== undefined) {
                localVarQueryParameter['include_all'] = includeAll;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} boardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalJobApiCensusAtsBoard: async (boardId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'boardId' is not null or undefined
            assertParamExists('externalJobApiCensusAtsBoard', 'boardId', boardId)
            const localVarPath = `/admin/ats-boards/{board_id}/census`
                .replace('{board_id}', encodeURIComponent(String(boardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {JobsPipeCensusBody} jobsPipeCensusBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalJobApiCensusJobspipe: async (jobsPipeCensusBody: JobsPipeCensusBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobsPipeCensusBody' is not null or undefined
            assertParamExists('externalJobApiCensusJobspipe', 'jobsPipeCensusBody', jobsPipeCensusBody)
            const localVarPath = `/admin/external-jobs/jobspipe/census`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(jobsPipeCensusBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateATSBoardBody} createATSBoardBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalJobApiCreateAtsBoard: async (createATSBoardBody: CreateATSBoardBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createATSBoardBody' is not null or undefined
            assertParamExists('externalJobApiCreateAtsBoard', 'createATSBoardBody', createATSBoardBody)
            const localVarPath = `/admin/ats-boards`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createATSBoardBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} boardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalJobApiDeleteAtsBoard: async (boardId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'boardId' is not null or undefined
            assertParamExists('externalJobApiDeleteAtsBoard', 'boardId', boardId)
            const localVarPath = `/admin/ats-boards/{board_id}`
                .replace('{board_id}', encodeURIComponent(String(boardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {FetchCatalogItemBody} fetchCatalogItemBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalJobApiFetchOneExternalJob: async (fetchCatalogItemBody: FetchCatalogItemBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fetchCatalogItemBody' is not null or undefined
            assertParamExists('externalJobApiFetchOneExternalJob', 'fetchCatalogItemBody', fetchCatalogItemBody)
            const localVarPath = `/admin/external-jobs/fetch-one`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fetchCatalogItemBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {FetchTopBody} fetchTopBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalJobApiFetchTopExternalJobs: async (fetchTopBody: FetchTopBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fetchTopBody' is not null or undefined
            assertParamExists('externalJobApiFetchTopExternalJobs', 'fetchTopBody', fetchTopBody)
            const localVarPath = `/admin/external-jobs/fetch-top`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fetchTopBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalJobApiGetExternalJobPreferences: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/external-jobs/preferences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} boardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalJobApiIngestAtsBoard: async (boardId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'boardId' is not null or undefined
            assertParamExists('externalJobApiIngestAtsBoard', 'boardId', boardId)
            const localVarPath = `/admin/ats-boards/{board_id}/ingest`
                .replace('{board_id}', encodeURIComponent(String(boardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {IngestCollectionBody} ingestCollectionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalJobApiIngestExternalCollection: async (ingestCollectionBody: IngestCollectionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ingestCollectionBody' is not null or undefined
            assertParamExists('externalJobApiIngestExternalCollection', 'ingestCollectionBody', ingestCollectionBody)
            const localVarPath = `/admin/external-jobs/collections/ingest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ingestCollectionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string | null} [category] 
         * @param {string | null} [_function] 
         * @param {boolean | null} [hasIndia] 
         * @param {boolean | null} [hasIndiaRemote] 
         * @param {boolean | null} [hasRemote] 
         * @param {boolean | null} [isActive] 
         * @param {number | null} [limit] 
         * @param {number | null} [maxRelevance] 
         * @param {number | null} [minJobs] 
         * @param {number | null} [minRelevance] 
         * @param {number | null} [offset] 
         * @param {string | null} [q] 
         * @param {string | null} [seniority] 
         * @param {ExternalJobApiListAtsBoardsSourceEnum} [source] 
         * @param {string | null} [tag] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalJobApiListAtsBoards: async (category?: string | null, _function?: string | null, hasIndia?: boolean | null, hasIndiaRemote?: boolean | null, hasRemote?: boolean | null, isActive?: boolean | null, limit?: number | null, maxRelevance?: number | null, minJobs?: number | null, minRelevance?: number | null, offset?: number | null, q?: string | null, seniority?: string | null, source?: ExternalJobApiListAtsBoardsSourceEnum, tag?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/ats-boards`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }

            if (_function !== undefined) {
                localVarQueryParameter['function'] = _function;
            }

            if (hasIndia !== undefined) {
                localVarQueryParameter['has_india'] = hasIndia;
            }

            if (hasIndiaRemote !== undefined) {
                localVarQueryParameter['has_india_remote'] = hasIndiaRemote;
            }

            if (hasRemote !== undefined) {
                localVarQueryParameter['has_remote'] = hasRemote;
            }

            if (isActive !== undefined) {
                localVarQueryParameter['is_active'] = isActive;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (maxRelevance !== undefined) {
                localVarQueryParameter['max_relevance'] = maxRelevance;
            }

            if (minJobs !== undefined) {
                localVarQueryParameter['min_jobs'] = minJobs;
            }

            if (minRelevance !== undefined) {
                localVarQueryParameter['min_relevance'] = minRelevance;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (seniority !== undefined) {
                localVarQueryParameter['seniority'] = seniority;
            }

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }

            if (tag !== undefined) {
                localVarQueryParameter['tag'] = tag;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} [includeInactive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalJobApiListBlockedExternalCompanies: async (includeInactive?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/external-jobs/blocked-companies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (includeInactive !== undefined) {
                localVarQueryParameter['include_inactive'] = includeInactive;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string | null} [boardId] 
         * @param {string | null} [country] 
         * @param {string | null} [_function] 
         * @param {boolean | null} [includeDuplicates] 
         * @param {boolean | null} [indiaOnly] 
         * @param {number | null} [minScore] 
         * @param {number | null} [page] 
         * @param {number | null} [pageSize] 
         * @param {number | null} [postedWithinDays] 
         * @param {boolean | null} [remoteOnly] 
         * @param {string | null} [search] 
         * @param {string | null} [seniority] 
         * @param {string | null} [source] 
         * @param {boolean | null} [unfetchedOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalJobApiListCatalogCountryFacets: async (boardId?: string | null, country?: string | null, _function?: string | null, includeDuplicates?: boolean | null, indiaOnly?: boolean | null, minScore?: number | null, page?: number | null, pageSize?: number | null, postedWithinDays?: number | null, remoteOnly?: boolean | null, search?: string | null, seniority?: string | null, source?: string | null, unfetchedOnly?: boolean | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/external-jobs/catalog/countries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (boardId !== undefined) {
                localVarQueryParameter['board_id'] = boardId;
            }

            if (country !== undefined) {
                localVarQueryParameter['country'] = country;
            }

            if (_function !== undefined) {
                localVarQueryParameter['function'] = _function;
            }

            if (includeDuplicates !== undefined) {
                localVarQueryParameter['include_duplicates'] = includeDuplicates;
            }

            if (indiaOnly !== undefined) {
                localVarQueryParameter['india_only'] = indiaOnly;
            }

            if (minScore !== undefined) {
                localVarQueryParameter['min_score'] = minScore;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (postedWithinDays !== undefined) {
                localVarQueryParameter['posted_within_days'] = postedWithinDays;
            }

            if (remoteOnly !== undefined) {
                localVarQueryParameter['remote_only'] = remoteOnly;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (seniority !== undefined) {
                localVarQueryParameter['seniority'] = seniority;
            }

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }

            if (unfetchedOnly !== undefined) {
                localVarQueryParameter['unfetched_only'] = unfetchedOnly;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [minBlocks] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalJobApiListCompanyBlockCandidates: async (minBlocks?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/external-jobs/block-candidates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (minBlocks !== undefined) {
                localVarQueryParameter['min_blocks'] = minBlocks;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalJobApiListExternalCollections: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/external-jobs/collections`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number | null} [page] 
         * @param {number | null} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalJobApiListExternalFetchRuns: async (page?: number | null, pageSize?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/external-jobs/fetch-runs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string | null} [boardId] 
         * @param {string | null} [country] 
         * @param {string | null} [_function] 
         * @param {boolean | null} [includeDuplicates] 
         * @param {boolean | null} [indiaOnly] 
         * @param {number | null} [minScore] 
         * @param {number | null} [page] 
         * @param {number | null} [pageSize] 
         * @param {number | null} [postedWithinDays] 
         * @param {boolean | null} [remoteOnly] 
         * @param {string | null} [search] 
         * @param {string | null} [seniority] 
         * @param {string | null} [source] 
         * @param {boolean | null} [unfetchedOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalJobApiListExternalJobCatalog: async (boardId?: string | null, country?: string | null, _function?: string | null, includeDuplicates?: boolean | null, indiaOnly?: boolean | null, minScore?: number | null, page?: number | null, pageSize?: number | null, postedWithinDays?: number | null, remoteOnly?: boolean | null, search?: string | null, seniority?: string | null, source?: string | null, unfetchedOnly?: boolean | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/external-jobs/catalog`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (boardId !== undefined) {
                localVarQueryParameter['board_id'] = boardId;
            }

            if (country !== undefined) {
                localVarQueryParameter['country'] = country;
            }

            if (_function !== undefined) {
                localVarQueryParameter['function'] = _function;
            }

            if (includeDuplicates !== undefined) {
                localVarQueryParameter['include_duplicates'] = includeDuplicates;
            }

            if (indiaOnly !== undefined) {
                localVarQueryParameter['india_only'] = indiaOnly;
            }

            if (minScore !== undefined) {
                localVarQueryParameter['min_score'] = minScore;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (postedWithinDays !== undefined) {
                localVarQueryParameter['posted_within_days'] = postedWithinDays;
            }

            if (remoteOnly !== undefined) {
                localVarQueryParameter['remote_only'] = remoteOnly;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (seniority !== undefined) {
                localVarQueryParameter['seniority'] = seniority;
            }

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }

            if (unfetchedOnly !== undefined) {
                localVarQueryParameter['unfetched_only'] = unfetchedOnly;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ActiveJobBody} activeJobBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalJobApiListExternalJobs: async (activeJobBody: ActiveJobBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'activeJobBody' is not null or undefined
            assertParamExists('externalJobApiListExternalJobs', 'activeJobBody', activeJobBody)
            const localVarPath = `/admin/external-jobs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(activeJobBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string | null} [company] 
         * @param {boolean | null} [includeReviewed] 
         * @param {number | null} [limit] 
         * @param {number | null} [maxGrade] 
         * @param {boolean | null} [remoteOnly] 
         * @param {string | null} [source] 
         * @param {boolean | null} [unscoredOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalJobApiListJobsForClaudeReview: async (company?: string | null, includeReviewed?: boolean | null, limit?: number | null, maxGrade?: number | null, remoteOnly?: boolean | null, source?: string | null, unscoredOnly?: boolean | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/external-jobs/claude-review`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (company !== undefined) {
                localVarQueryParameter['company'] = company;
            }

            if (includeReviewed !== undefined) {
                localVarQueryParameter['include_reviewed'] = includeReviewed;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (maxGrade !== undefined) {
                localVarQueryParameter['max_grade'] = maxGrade;
            }

            if (remoteOnly !== undefined) {
                localVarQueryParameter['remote_only'] = remoteOnly;
            }

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }

            if (unscoredOnly !== undefined) {
                localVarQueryParameter['unscored_only'] = unscoredOnly;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalJobApiPreviewAutoPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/external-jobs/auto-post/preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {FetchRequestBody} fetchRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalJobApiPreviewExternalFetch: async (fetchRequestBody: FetchRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fetchRequestBody' is not null or undefined
            assertParamExists('externalJobApiPreviewExternalFetch', 'fetchRequestBody', fetchRequestBody)
            const localVarPath = `/admin/external-jobs/fetch/preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fetchRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReconcileThinBody} reconcileThinBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalJobApiReconcileThinExternalJobs: async (reconcileThinBody: ReconcileThinBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reconcileThinBody' is not null or undefined
            assertParamExists('externalJobApiReconcileThinExternalJobs', 'reconcileThinBody', reconcileThinBody)
            const localVarPath = `/admin/external-jobs/reconcile-thin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reconcileThinBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RescoreCatalogBody} rescoreCatalogBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalJobApiRescoreExternalCatalogRoute: async (rescoreCatalogBody: RescoreCatalogBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rescoreCatalogBody' is not null or undefined
            assertParamExists('externalJobApiRescoreExternalCatalogRoute', 'rescoreCatalogBody', rescoreCatalogBody)
            const localVarPath = `/admin/external-jobs/rescore-catalog`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rescoreCatalogBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {FetchRequestBody} fetchRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalJobApiRunExternalFetch: async (fetchRequestBody: FetchRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fetchRequestBody' is not null or undefined
            assertParamExists('externalJobApiRunExternalFetch', 'fetchRequestBody', fetchRequestBody)
            const localVarPath = `/admin/external-jobs/fetch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fetchRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalJobApiSeedExternalCollections: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/external-jobs/collections/seed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SetATSBoardScoresBody} setATSBoardScoresBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalJobApiSetAtsBoardScores: async (setATSBoardScoresBody: SetATSBoardScoresBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'setATSBoardScoresBody' is not null or undefined
            assertParamExists('externalJobApiSetAtsBoardScores', 'setATSBoardScoresBody', setATSBoardScoresBody)
            const localVarPath = `/admin/ats-boards/scores`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setATSBoardScoresBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {HygieneSweepBody} hygieneSweepBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalJobApiSweepExternalJobHygiene: async (hygieneSweepBody: HygieneSweepBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hygieneSweepBody' is not null or undefined
            assertParamExists('externalJobApiSweepExternalJobHygiene', 'hygieneSweepBody', hygieneSweepBody)
            const localVarPath = `/admin/external-jobs/hygiene-sweep`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(hygieneSweepBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TargetedIngestBody} targetedIngestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalJobApiTargetedExternalIngest: async (targetedIngestBody: TargetedIngestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'targetedIngestBody' is not null or undefined
            assertParamExists('externalJobApiTargetedExternalIngest', 'targetedIngestBody', targetedIngestBody)
            const localVarPath = `/admin/external-jobs/targeted-ingest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(targetedIngestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} blockId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalJobApiUnblockExternalCompany: async (blockId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'blockId' is not null or undefined
            assertParamExists('externalJobApiUnblockExternalCompany', 'blockId', blockId)
            const localVarPath = `/admin/external-jobs/blocked-companies/{block_id}`
                .replace('{block_id}', encodeURIComponent(String(blockId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} boardId 
         * @param {UpdateATSBoardBody} updateATSBoardBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalJobApiUpdateAtsBoard: async (boardId: string, updateATSBoardBody: UpdateATSBoardBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'boardId' is not null or undefined
            assertParamExists('externalJobApiUpdateAtsBoard', 'boardId', boardId)
            // verify required parameter 'updateATSBoardBody' is not null or undefined
            assertParamExists('externalJobApiUpdateAtsBoard', 'updateATSBoardBody', updateATSBoardBody)
            const localVarPath = `/admin/ats-boards/{board_id}`
                .replace('{board_id}', encodeURIComponent(String(boardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateATSBoardBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateExternalJobPreferenceBody} updateExternalJobPreferenceBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalJobApiUpdateExternalJobPreference: async (updateExternalJobPreferenceBody: UpdateExternalJobPreferenceBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateExternalJobPreferenceBody' is not null or undefined
            assertParamExists('externalJobApiUpdateExternalJobPreference', 'updateExternalJobPreferenceBody', updateExternalJobPreferenceBody)
            const localVarPath = `/admin/external-jobs/preferences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateExternalJobPreferenceBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExternalJobApiApi - functional programming interface
 */
export const ExternalJobApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExternalJobApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ClaudeReviewVerdictsBody} claudeReviewVerdictsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async externalJobApiApplyClaudeReviewVerdicts(claudeReviewVerdictsBody: ClaudeReviewVerdictsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClaudeReviewVerdictsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.externalJobApiApplyClaudeReviewVerdicts(claudeReviewVerdictsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalJobApiApi.externalJobApiApplyClaudeReviewVerdicts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {BackfillLocationsBody} backfillLocationsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async externalJobApiBackfillExternalJobLocationsRoute(backfillLocationsBody: BackfillLocationsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BackfillLocationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.externalJobApiBackfillExternalJobLocationsRoute(backfillLocationsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalJobApiApi.externalJobApiBackfillExternalJobLocationsRoute']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {BlockCompanyBody} blockCompanyBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async externalJobApiBlockExternalCompany(blockCompanyBody: BlockCompanyBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BlockCompanyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.externalJobApiBlockExternalCompany(blockCompanyBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalJobApiApi.externalJobApiBlockExternalCompany']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {BulkCreateATSBoardsBody} bulkCreateATSBoardsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async externalJobApiBulkCreateAtsBoards(bulkCreateATSBoardsBody: BulkCreateATSBoardsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkCreateATSBoardsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.externalJobApiBulkCreateAtsBoards(bulkCreateATSBoardsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalJobApiApi.externalJobApiBulkCreateAtsBoards']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {boolean} [includeAll] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async externalJobApiCensusAllAtsBoards(includeAll?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CensusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.externalJobApiCensusAllAtsBoards(includeAll, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalJobApiApi.externalJobApiCensusAllAtsBoards']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} boardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async externalJobApiCensusAtsBoard(boardId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CensusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.externalJobApiCensusAtsBoard(boardId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalJobApiApi.externalJobApiCensusAtsBoard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {JobsPipeCensusBody} jobsPipeCensusBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async externalJobApiCensusJobspipe(jobsPipeCensusBody: JobsPipeCensusBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobsPipeCensusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.externalJobApiCensusJobspipe(jobsPipeCensusBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalJobApiApi.externalJobApiCensusJobspipe']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateATSBoardBody} createATSBoardBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async externalJobApiCreateAtsBoard(createATSBoardBody: CreateATSBoardBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ATSBoardResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.externalJobApiCreateAtsBoard(createATSBoardBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalJobApiApi.externalJobApiCreateAtsBoard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} boardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async externalJobApiDeleteAtsBoard(boardId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.externalJobApiDeleteAtsBoard(boardId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalJobApiApi.externalJobApiDeleteAtsBoard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {FetchCatalogItemBody} fetchCatalogItemBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async externalJobApiFetchOneExternalJob(fetchCatalogItemBody: FetchCatalogItemBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FetchCatalogItemResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.externalJobApiFetchOneExternalJob(fetchCatalogItemBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalJobApiApi.externalJobApiFetchOneExternalJob']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {FetchTopBody} fetchTopBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async externalJobApiFetchTopExternalJobs(fetchTopBody: FetchTopBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FetchTopResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.externalJobApiFetchTopExternalJobs(fetchTopBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalJobApiApi.externalJobApiFetchTopExternalJobs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async externalJobApiGetExternalJobPreferences(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExternalJobPreferencesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.externalJobApiGetExternalJobPreferences(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalJobApiApi.externalJobApiGetExternalJobPreferences']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} boardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async externalJobApiIngestAtsBoard(boardId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IngestResultResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.externalJobApiIngestAtsBoard(boardId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalJobApiApi.externalJobApiIngestAtsBoard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {IngestCollectionBody} ingestCollectionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async externalJobApiIngestExternalCollection(ingestCollectionBody: IngestCollectionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CollectionIngestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.externalJobApiIngestExternalCollection(ingestCollectionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalJobApiApi.externalJobApiIngestExternalCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string | null} [category] 
         * @param {string | null} [_function] 
         * @param {boolean | null} [hasIndia] 
         * @param {boolean | null} [hasIndiaRemote] 
         * @param {boolean | null} [hasRemote] 
         * @param {boolean | null} [isActive] 
         * @param {number | null} [limit] 
         * @param {number | null} [maxRelevance] 
         * @param {number | null} [minJobs] 
         * @param {number | null} [minRelevance] 
         * @param {number | null} [offset] 
         * @param {string | null} [q] 
         * @param {string | null} [seniority] 
         * @param {ExternalJobApiListAtsBoardsSourceEnum} [source] 
         * @param {string | null} [tag] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async externalJobApiListAtsBoards(category?: string | null, _function?: string | null, hasIndia?: boolean | null, hasIndiaRemote?: boolean | null, hasRemote?: boolean | null, isActive?: boolean | null, limit?: number | null, maxRelevance?: number | null, minJobs?: number | null, minRelevance?: number | null, offset?: number | null, q?: string | null, seniority?: string | null, source?: ExternalJobApiListAtsBoardsSourceEnum, tag?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ATSBoardListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.externalJobApiListAtsBoards(category, _function, hasIndia, hasIndiaRemote, hasRemote, isActive, limit, maxRelevance, minJobs, minRelevance, offset, q, seniority, source, tag, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalJobApiApi.externalJobApiListAtsBoards']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {boolean} [includeInactive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async externalJobApiListBlockedExternalCompanies(includeInactive?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BlockedCompanyListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.externalJobApiListBlockedExternalCompanies(includeInactive, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalJobApiApi.externalJobApiListBlockedExternalCompanies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string | null} [boardId] 
         * @param {string | null} [country] 
         * @param {string | null} [_function] 
         * @param {boolean | null} [includeDuplicates] 
         * @param {boolean | null} [indiaOnly] 
         * @param {number | null} [minScore] 
         * @param {number | null} [page] 
         * @param {number | null} [pageSize] 
         * @param {number | null} [postedWithinDays] 
         * @param {boolean | null} [remoteOnly] 
         * @param {string | null} [search] 
         * @param {string | null} [seniority] 
         * @param {string | null} [source] 
         * @param {boolean | null} [unfetchedOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async externalJobApiListCatalogCountryFacets(boardId?: string | null, country?: string | null, _function?: string | null, includeDuplicates?: boolean | null, indiaOnly?: boolean | null, minScore?: number | null, page?: number | null, pageSize?: number | null, postedWithinDays?: number | null, remoteOnly?: boolean | null, search?: string | null, seniority?: string | null, source?: string | null, unfetchedOnly?: boolean | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CatalogCountryFacetsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.externalJobApiListCatalogCountryFacets(boardId, country, _function, includeDuplicates, indiaOnly, minScore, page, pageSize, postedWithinDays, remoteOnly, search, seniority, source, unfetchedOnly, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalJobApiApi.externalJobApiListCatalogCountryFacets']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [minBlocks] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async externalJobApiListCompanyBlockCandidates(minBlocks?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BlockCandidateListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.externalJobApiListCompanyBlockCandidates(minBlocks, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalJobApiApi.externalJobApiListCompanyBlockCandidates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async externalJobApiListExternalCollections(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CollectionListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.externalJobApiListExternalCollections(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalJobApiApi.externalJobApiListExternalCollections']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number | null} [page] 
         * @param {number | null} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async externalJobApiListExternalFetchRuns(page?: number | null, pageSize?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FetchRunListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.externalJobApiListExternalFetchRuns(page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalJobApiApi.externalJobApiListExternalFetchRuns']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string | null} [boardId] 
         * @param {string | null} [country] 
         * @param {string | null} [_function] 
         * @param {boolean | null} [includeDuplicates] 
         * @param {boolean | null} [indiaOnly] 
         * @param {number | null} [minScore] 
         * @param {number | null} [page] 
         * @param {number | null} [pageSize] 
         * @param {number | null} [postedWithinDays] 
         * @param {boolean | null} [remoteOnly] 
         * @param {string | null} [search] 
         * @param {string | null} [seniority] 
         * @param {string | null} [source] 
         * @param {boolean | null} [unfetchedOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async externalJobApiListExternalJobCatalog(boardId?: string | null, country?: string | null, _function?: string | null, includeDuplicates?: boolean | null, indiaOnly?: boolean | null, minScore?: number | null, page?: number | null, pageSize?: number | null, postedWithinDays?: number | null, remoteOnly?: boolean | null, search?: string | null, seniority?: string | null, source?: string | null, unfetchedOnly?: boolean | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CatalogListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.externalJobApiListExternalJobCatalog(boardId, country, _function, includeDuplicates, indiaOnly, minScore, page, pageSize, postedWithinDays, remoteOnly, search, seniority, source, unfetchedOnly, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalJobApiApi.externalJobApiListExternalJobCatalog']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ActiveJobBody} activeJobBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async externalJobApiListExternalJobs(activeJobBody: ActiveJobBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActiveJobsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.externalJobApiListExternalJobs(activeJobBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalJobApiApi.externalJobApiListExternalJobs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string | null} [company] 
         * @param {boolean | null} [includeReviewed] 
         * @param {number | null} [limit] 
         * @param {number | null} [maxGrade] 
         * @param {boolean | null} [remoteOnly] 
         * @param {string | null} [source] 
         * @param {boolean | null} [unscoredOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async externalJobApiListJobsForClaudeReview(company?: string | null, includeReviewed?: boolean | null, limit?: number | null, maxGrade?: number | null, remoteOnly?: boolean | null, source?: string | null, unscoredOnly?: boolean | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClaudeReviewListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.externalJobApiListJobsForClaudeReview(company, includeReviewed, limit, maxGrade, remoteOnly, source, unscoredOnly, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalJobApiApi.externalJobApiListJobsForClaudeReview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async externalJobApiPreviewAutoPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AutoPostPreviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.externalJobApiPreviewAutoPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalJobApiApi.externalJobApiPreviewAutoPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {FetchRequestBody} fetchRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async externalJobApiPreviewExternalFetch(fetchRequestBody: FetchRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PreviewFetchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.externalJobApiPreviewExternalFetch(fetchRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalJobApiApi.externalJobApiPreviewExternalFetch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ReconcileThinBody} reconcileThinBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async externalJobApiReconcileThinExternalJobs(reconcileThinBody: ReconcileThinBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReconcileThinResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.externalJobApiReconcileThinExternalJobs(reconcileThinBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalJobApiApi.externalJobApiReconcileThinExternalJobs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {RescoreCatalogBody} rescoreCatalogBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async externalJobApiRescoreExternalCatalogRoute(rescoreCatalogBody: RescoreCatalogBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BackfillLocationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.externalJobApiRescoreExternalCatalogRoute(rescoreCatalogBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalJobApiApi.externalJobApiRescoreExternalCatalogRoute']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {FetchRequestBody} fetchRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async externalJobApiRunExternalFetch(fetchRequestBody: FetchRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FetchRunResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.externalJobApiRunExternalFetch(fetchRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalJobApiApi.externalJobApiRunExternalFetch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async externalJobApiSeedExternalCollections(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SeedCollectionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.externalJobApiSeedExternalCollections(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalJobApiApi.externalJobApiSeedExternalCollections']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SetATSBoardScoresBody} setATSBoardScoresBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async externalJobApiSetAtsBoardScores(setATSBoardScoresBody: SetATSBoardScoresBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SetATSBoardScoresResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.externalJobApiSetAtsBoardScores(setATSBoardScoresBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalJobApiApi.externalJobApiSetAtsBoardScores']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {HygieneSweepBody} hygieneSweepBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async externalJobApiSweepExternalJobHygiene(hygieneSweepBody: HygieneSweepBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HygieneSweepResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.externalJobApiSweepExternalJobHygiene(hygieneSweepBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalJobApiApi.externalJobApiSweepExternalJobHygiene']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {TargetedIngestBody} targetedIngestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async externalJobApiTargetedExternalIngest(targetedIngestBody: TargetedIngestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TargetedIngestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.externalJobApiTargetedExternalIngest(targetedIngestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalJobApiApi.externalJobApiTargetedExternalIngest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} blockId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async externalJobApiUnblockExternalCompany(blockId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnblockCompanyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.externalJobApiUnblockExternalCompany(blockId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalJobApiApi.externalJobApiUnblockExternalCompany']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} boardId 
         * @param {UpdateATSBoardBody} updateATSBoardBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async externalJobApiUpdateAtsBoard(boardId: string, updateATSBoardBody: UpdateATSBoardBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ATSBoardResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.externalJobApiUpdateAtsBoard(boardId, updateATSBoardBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalJobApiApi.externalJobApiUpdateAtsBoard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateExternalJobPreferenceBody} updateExternalJobPreferenceBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async externalJobApiUpdateExternalJobPreference(updateExternalJobPreferenceBody: UpdateExternalJobPreferenceBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExternalJobPreferencesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.externalJobApiUpdateExternalJobPreference(updateExternalJobPreferenceBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalJobApiApi.externalJobApiUpdateExternalJobPreference']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ExternalJobApiApi - factory interface
 */
export const ExternalJobApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExternalJobApiApiFp(configuration)
    return {
        /**
         * 
         * @param {ExternalJobApiApiExternalJobApiApplyClaudeReviewVerdictsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalJobApiApplyClaudeReviewVerdicts(requestParameters: ExternalJobApiApiExternalJobApiApplyClaudeReviewVerdictsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClaudeReviewVerdictsResponse> {
            return localVarFp.externalJobApiApplyClaudeReviewVerdicts(requestParameters.claudeReviewVerdictsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExternalJobApiApiExternalJobApiBackfillExternalJobLocationsRouteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalJobApiBackfillExternalJobLocationsRoute(requestParameters: ExternalJobApiApiExternalJobApiBackfillExternalJobLocationsRouteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BackfillLocationsResponse> {
            return localVarFp.externalJobApiBackfillExternalJobLocationsRoute(requestParameters.backfillLocationsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExternalJobApiApiExternalJobApiBlockExternalCompanyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalJobApiBlockExternalCompany(requestParameters: ExternalJobApiApiExternalJobApiBlockExternalCompanyRequest, options?: RawAxiosRequestConfig): AxiosPromise<BlockCompanyResponse> {
            return localVarFp.externalJobApiBlockExternalCompany(requestParameters.blockCompanyBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExternalJobApiApiExternalJobApiBulkCreateAtsBoardsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalJobApiBulkCreateAtsBoards(requestParameters: ExternalJobApiApiExternalJobApiBulkCreateAtsBoardsRequest, options?: RawAxiosRequestConfig): AxiosPromise<BulkCreateATSBoardsResponse> {
            return localVarFp.externalJobApiBulkCreateAtsBoards(requestParameters.bulkCreateATSBoardsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExternalJobApiApiExternalJobApiCensusAllAtsBoardsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalJobApiCensusAllAtsBoards(requestParameters: ExternalJobApiApiExternalJobApiCensusAllAtsBoardsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<CensusResponse> {
            return localVarFp.externalJobApiCensusAllAtsBoards(requestParameters.includeAll, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExternalJobApiApiExternalJobApiCensusAtsBoardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalJobApiCensusAtsBoard(requestParameters: ExternalJobApiApiExternalJobApiCensusAtsBoardRequest, options?: RawAxiosRequestConfig): AxiosPromise<CensusResponse> {
            return localVarFp.externalJobApiCensusAtsBoard(requestParameters.boardId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExternalJobApiApiExternalJobApiCensusJobspipeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalJobApiCensusJobspipe(requestParameters: ExternalJobApiApiExternalJobApiCensusJobspipeRequest, options?: RawAxiosRequestConfig): AxiosPromise<JobsPipeCensusResponse> {
            return localVarFp.externalJobApiCensusJobspipe(requestParameters.jobsPipeCensusBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExternalJobApiApiExternalJobApiCreateAtsBoardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalJobApiCreateAtsBoard(requestParameters: ExternalJobApiApiExternalJobApiCreateAtsBoardRequest, options?: RawAxiosRequestConfig): AxiosPromise<ATSBoardResponse> {
            return localVarFp.externalJobApiCreateAtsBoard(requestParameters.createATSBoardBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExternalJobApiApiExternalJobApiDeleteAtsBoardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalJobApiDeleteAtsBoard(requestParameters: ExternalJobApiApiExternalJobApiDeleteAtsBoardRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.externalJobApiDeleteAtsBoard(requestParameters.boardId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExternalJobApiApiExternalJobApiFetchOneExternalJobRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalJobApiFetchOneExternalJob(requestParameters: ExternalJobApiApiExternalJobApiFetchOneExternalJobRequest, options?: RawAxiosRequestConfig): AxiosPromise<FetchCatalogItemResponse> {
            return localVarFp.externalJobApiFetchOneExternalJob(requestParameters.fetchCatalogItemBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExternalJobApiApiExternalJobApiFetchTopExternalJobsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalJobApiFetchTopExternalJobs(requestParameters: ExternalJobApiApiExternalJobApiFetchTopExternalJobsRequest, options?: RawAxiosRequestConfig): AxiosPromise<FetchTopResponse> {
            return localVarFp.externalJobApiFetchTopExternalJobs(requestParameters.fetchTopBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalJobApiGetExternalJobPreferences(options?: RawAxiosRequestConfig): AxiosPromise<ExternalJobPreferencesResponse> {
            return localVarFp.externalJobApiGetExternalJobPreferences(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExternalJobApiApiExternalJobApiIngestAtsBoardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalJobApiIngestAtsBoard(requestParameters: ExternalJobApiApiExternalJobApiIngestAtsBoardRequest, options?: RawAxiosRequestConfig): AxiosPromise<IngestResultResponse> {
            return localVarFp.externalJobApiIngestAtsBoard(requestParameters.boardId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExternalJobApiApiExternalJobApiIngestExternalCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalJobApiIngestExternalCollection(requestParameters: ExternalJobApiApiExternalJobApiIngestExternalCollectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<CollectionIngestResponse> {
            return localVarFp.externalJobApiIngestExternalCollection(requestParameters.ingestCollectionBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExternalJobApiApiExternalJobApiListAtsBoardsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalJobApiListAtsBoards(requestParameters: ExternalJobApiApiExternalJobApiListAtsBoardsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ATSBoardListResponse> {
            return localVarFp.externalJobApiListAtsBoards(requestParameters.category, requestParameters._function, requestParameters.hasIndia, requestParameters.hasIndiaRemote, requestParameters.hasRemote, requestParameters.isActive, requestParameters.limit, requestParameters.maxRelevance, requestParameters.minJobs, requestParameters.minRelevance, requestParameters.offset, requestParameters.q, requestParameters.seniority, requestParameters.source, requestParameters.tag, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExternalJobApiApiExternalJobApiListBlockedExternalCompaniesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalJobApiListBlockedExternalCompanies(requestParameters: ExternalJobApiApiExternalJobApiListBlockedExternalCompaniesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<BlockedCompanyListResponse> {
            return localVarFp.externalJobApiListBlockedExternalCompanies(requestParameters.includeInactive, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExternalJobApiApiExternalJobApiListCatalogCountryFacetsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalJobApiListCatalogCountryFacets(requestParameters: ExternalJobApiApiExternalJobApiListCatalogCountryFacetsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<CatalogCountryFacetsResponse> {
            return localVarFp.externalJobApiListCatalogCountryFacets(requestParameters.boardId, requestParameters.country, requestParameters._function, requestParameters.includeDuplicates, requestParameters.indiaOnly, requestParameters.minScore, requestParameters.page, requestParameters.pageSize, requestParameters.postedWithinDays, requestParameters.remoteOnly, requestParameters.search, requestParameters.seniority, requestParameters.source, requestParameters.unfetchedOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExternalJobApiApiExternalJobApiListCompanyBlockCandidatesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalJobApiListCompanyBlockCandidates(requestParameters: ExternalJobApiApiExternalJobApiListCompanyBlockCandidatesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<BlockCandidateListResponse> {
            return localVarFp.externalJobApiListCompanyBlockCandidates(requestParameters.minBlocks, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalJobApiListExternalCollections(options?: RawAxiosRequestConfig): AxiosPromise<CollectionListResponse> {
            return localVarFp.externalJobApiListExternalCollections(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExternalJobApiApiExternalJobApiListExternalFetchRunsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalJobApiListExternalFetchRuns(requestParameters: ExternalJobApiApiExternalJobApiListExternalFetchRunsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<FetchRunListResponse> {
            return localVarFp.externalJobApiListExternalFetchRuns(requestParameters.page, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExternalJobApiApiExternalJobApiListExternalJobCatalogRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalJobApiListExternalJobCatalog(requestParameters: ExternalJobApiApiExternalJobApiListExternalJobCatalogRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<CatalogListResponse> {
            return localVarFp.externalJobApiListExternalJobCatalog(requestParameters.boardId, requestParameters.country, requestParameters._function, requestParameters.includeDuplicates, requestParameters.indiaOnly, requestParameters.minScore, requestParameters.page, requestParameters.pageSize, requestParameters.postedWithinDays, requestParameters.remoteOnly, requestParameters.search, requestParameters.seniority, requestParameters.source, requestParameters.unfetchedOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExternalJobApiApiExternalJobApiListExternalJobsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalJobApiListExternalJobs(requestParameters: ExternalJobApiApiExternalJobApiListExternalJobsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ActiveJobsResponse> {
            return localVarFp.externalJobApiListExternalJobs(requestParameters.activeJobBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExternalJobApiApiExternalJobApiListJobsForClaudeReviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalJobApiListJobsForClaudeReview(requestParameters: ExternalJobApiApiExternalJobApiListJobsForClaudeReviewRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ClaudeReviewListResponse> {
            return localVarFp.externalJobApiListJobsForClaudeReview(requestParameters.company, requestParameters.includeReviewed, requestParameters.limit, requestParameters.maxGrade, requestParameters.remoteOnly, requestParameters.source, requestParameters.unscoredOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalJobApiPreviewAutoPost(options?: RawAxiosRequestConfig): AxiosPromise<AutoPostPreviewResponse> {
            return localVarFp.externalJobApiPreviewAutoPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExternalJobApiApiExternalJobApiPreviewExternalFetchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalJobApiPreviewExternalFetch(requestParameters: ExternalJobApiApiExternalJobApiPreviewExternalFetchRequest, options?: RawAxiosRequestConfig): AxiosPromise<PreviewFetchResponse> {
            return localVarFp.externalJobApiPreviewExternalFetch(requestParameters.fetchRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExternalJobApiApiExternalJobApiReconcileThinExternalJobsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalJobApiReconcileThinExternalJobs(requestParameters: ExternalJobApiApiExternalJobApiReconcileThinExternalJobsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReconcileThinResponse> {
            return localVarFp.externalJobApiReconcileThinExternalJobs(requestParameters.reconcileThinBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExternalJobApiApiExternalJobApiRescoreExternalCatalogRouteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalJobApiRescoreExternalCatalogRoute(requestParameters: ExternalJobApiApiExternalJobApiRescoreExternalCatalogRouteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BackfillLocationsResponse> {
            return localVarFp.externalJobApiRescoreExternalCatalogRoute(requestParameters.rescoreCatalogBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExternalJobApiApiExternalJobApiRunExternalFetchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalJobApiRunExternalFetch(requestParameters: ExternalJobApiApiExternalJobApiRunExternalFetchRequest, options?: RawAxiosRequestConfig): AxiosPromise<FetchRunResponse> {
            return localVarFp.externalJobApiRunExternalFetch(requestParameters.fetchRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalJobApiSeedExternalCollections(options?: RawAxiosRequestConfig): AxiosPromise<SeedCollectionsResponse> {
            return localVarFp.externalJobApiSeedExternalCollections(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExternalJobApiApiExternalJobApiSetAtsBoardScoresRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalJobApiSetAtsBoardScores(requestParameters: ExternalJobApiApiExternalJobApiSetAtsBoardScoresRequest, options?: RawAxiosRequestConfig): AxiosPromise<SetATSBoardScoresResponse> {
            return localVarFp.externalJobApiSetAtsBoardScores(requestParameters.setATSBoardScoresBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExternalJobApiApiExternalJobApiSweepExternalJobHygieneRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalJobApiSweepExternalJobHygiene(requestParameters: ExternalJobApiApiExternalJobApiSweepExternalJobHygieneRequest, options?: RawAxiosRequestConfig): AxiosPromise<HygieneSweepResponse> {
            return localVarFp.externalJobApiSweepExternalJobHygiene(requestParameters.hygieneSweepBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExternalJobApiApiExternalJobApiTargetedExternalIngestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalJobApiTargetedExternalIngest(requestParameters: ExternalJobApiApiExternalJobApiTargetedExternalIngestRequest, options?: RawAxiosRequestConfig): AxiosPromise<TargetedIngestResponse> {
            return localVarFp.externalJobApiTargetedExternalIngest(requestParameters.targetedIngestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExternalJobApiApiExternalJobApiUnblockExternalCompanyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalJobApiUnblockExternalCompany(requestParameters: ExternalJobApiApiExternalJobApiUnblockExternalCompanyRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnblockCompanyResponse> {
            return localVarFp.externalJobApiUnblockExternalCompany(requestParameters.blockId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExternalJobApiApiExternalJobApiUpdateAtsBoardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalJobApiUpdateAtsBoard(requestParameters: ExternalJobApiApiExternalJobApiUpdateAtsBoardRequest, options?: RawAxiosRequestConfig): AxiosPromise<ATSBoardResponse> {
            return localVarFp.externalJobApiUpdateAtsBoard(requestParameters.boardId, requestParameters.updateATSBoardBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExternalJobApiApiExternalJobApiUpdateExternalJobPreferenceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalJobApiUpdateExternalJobPreference(requestParameters: ExternalJobApiApiExternalJobApiUpdateExternalJobPreferenceRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExternalJobPreferencesResponse> {
            return localVarFp.externalJobApiUpdateExternalJobPreference(requestParameters.updateExternalJobPreferenceBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for externalJobApiApplyClaudeReviewVerdicts operation in ExternalJobApiApi.
 */
export interface ExternalJobApiApiExternalJobApiApplyClaudeReviewVerdictsRequest {
    readonly claudeReviewVerdictsBody: ClaudeReviewVerdictsBody
}

/**
 * Request parameters for externalJobApiBackfillExternalJobLocationsRoute operation in ExternalJobApiApi.
 */
export interface ExternalJobApiApiExternalJobApiBackfillExternalJobLocationsRouteRequest {
    readonly backfillLocationsBody: BackfillLocationsBody
}

/**
 * Request parameters for externalJobApiBlockExternalCompany operation in ExternalJobApiApi.
 */
export interface ExternalJobApiApiExternalJobApiBlockExternalCompanyRequest {
    readonly blockCompanyBody: BlockCompanyBody
}

/**
 * Request parameters for externalJobApiBulkCreateAtsBoards operation in ExternalJobApiApi.
 */
export interface ExternalJobApiApiExternalJobApiBulkCreateAtsBoardsRequest {
    readonly bulkCreateATSBoardsBody: BulkCreateATSBoardsBody
}

/**
 * Request parameters for externalJobApiCensusAllAtsBoards operation in ExternalJobApiApi.
 */
export interface ExternalJobApiApiExternalJobApiCensusAllAtsBoardsRequest {
    readonly includeAll?: boolean
}

/**
 * Request parameters for externalJobApiCensusAtsBoard operation in ExternalJobApiApi.
 */
export interface ExternalJobApiApiExternalJobApiCensusAtsBoardRequest {
    readonly boardId: string
}

/**
 * Request parameters for externalJobApiCensusJobspipe operation in ExternalJobApiApi.
 */
export interface ExternalJobApiApiExternalJobApiCensusJobspipeRequest {
    readonly jobsPipeCensusBody: JobsPipeCensusBody
}

/**
 * Request parameters for externalJobApiCreateAtsBoard operation in ExternalJobApiApi.
 */
export interface ExternalJobApiApiExternalJobApiCreateAtsBoardRequest {
    readonly createATSBoardBody: CreateATSBoardBody
}

/**
 * Request parameters for externalJobApiDeleteAtsBoard operation in ExternalJobApiApi.
 */
export interface ExternalJobApiApiExternalJobApiDeleteAtsBoardRequest {
    readonly boardId: string
}

/**
 * Request parameters for externalJobApiFetchOneExternalJob operation in ExternalJobApiApi.
 */
export interface ExternalJobApiApiExternalJobApiFetchOneExternalJobRequest {
    readonly fetchCatalogItemBody: FetchCatalogItemBody
}

/**
 * Request parameters for externalJobApiFetchTopExternalJobs operation in ExternalJobApiApi.
 */
export interface ExternalJobApiApiExternalJobApiFetchTopExternalJobsRequest {
    readonly fetchTopBody: FetchTopBody
}

/**
 * Request parameters for externalJobApiIngestAtsBoard operation in ExternalJobApiApi.
 */
export interface ExternalJobApiApiExternalJobApiIngestAtsBoardRequest {
    readonly boardId: string
}

/**
 * Request parameters for externalJobApiIngestExternalCollection operation in ExternalJobApiApi.
 */
export interface ExternalJobApiApiExternalJobApiIngestExternalCollectionRequest {
    readonly ingestCollectionBody: IngestCollectionBody
}

/**
 * Request parameters for externalJobApiListAtsBoards operation in ExternalJobApiApi.
 */
export interface ExternalJobApiApiExternalJobApiListAtsBoardsRequest {
    readonly category?: string | null

    readonly _function?: string | null

    readonly hasIndia?: boolean | null

    readonly hasIndiaRemote?: boolean | null

    readonly hasRemote?: boolean | null

    readonly isActive?: boolean | null

    readonly limit?: number | null

    readonly maxRelevance?: number | null

    readonly minJobs?: number | null

    readonly minRelevance?: number | null

    readonly offset?: number | null

    readonly q?: string | null

    readonly seniority?: string | null

    readonly source?: ExternalJobApiListAtsBoardsSourceEnum

    readonly tag?: string | null
}

/**
 * Request parameters for externalJobApiListBlockedExternalCompanies operation in ExternalJobApiApi.
 */
export interface ExternalJobApiApiExternalJobApiListBlockedExternalCompaniesRequest {
    readonly includeInactive?: boolean
}

/**
 * Request parameters for externalJobApiListCatalogCountryFacets operation in ExternalJobApiApi.
 */
export interface ExternalJobApiApiExternalJobApiListCatalogCountryFacetsRequest {
    readonly boardId?: string | null

    readonly country?: string | null

    readonly _function?: string | null

    readonly includeDuplicates?: boolean | null

    readonly indiaOnly?: boolean | null

    readonly minScore?: number | null

    readonly page?: number | null

    readonly pageSize?: number | null

    readonly postedWithinDays?: number | null

    readonly remoteOnly?: boolean | null

    readonly search?: string | null

    readonly seniority?: string | null

    readonly source?: string | null

    readonly unfetchedOnly?: boolean | null
}

/**
 * Request parameters for externalJobApiListCompanyBlockCandidates operation in ExternalJobApiApi.
 */
export interface ExternalJobApiApiExternalJobApiListCompanyBlockCandidatesRequest {
    readonly minBlocks?: number
}

/**
 * Request parameters for externalJobApiListExternalFetchRuns operation in ExternalJobApiApi.
 */
export interface ExternalJobApiApiExternalJobApiListExternalFetchRunsRequest {
    readonly page?: number | null

    readonly pageSize?: number | null
}

/**
 * Request parameters for externalJobApiListExternalJobCatalog operation in ExternalJobApiApi.
 */
export interface ExternalJobApiApiExternalJobApiListExternalJobCatalogRequest {
    readonly boardId?: string | null

    readonly country?: string | null

    readonly _function?: string | null

    readonly includeDuplicates?: boolean | null

    readonly indiaOnly?: boolean | null

    readonly minScore?: number | null

    readonly page?: number | null

    readonly pageSize?: number | null

    readonly postedWithinDays?: number | null

    readonly remoteOnly?: boolean | null

    readonly search?: string | null

    readonly seniority?: string | null

    readonly source?: string | null

    readonly unfetchedOnly?: boolean | null
}

/**
 * Request parameters for externalJobApiListExternalJobs operation in ExternalJobApiApi.
 */
export interface ExternalJobApiApiExternalJobApiListExternalJobsRequest {
    readonly activeJobBody: ActiveJobBody
}

/**
 * Request parameters for externalJobApiListJobsForClaudeReview operation in ExternalJobApiApi.
 */
export interface ExternalJobApiApiExternalJobApiListJobsForClaudeReviewRequest {
    readonly company?: string | null

    readonly includeReviewed?: boolean | null

    readonly limit?: number | null

    readonly maxGrade?: number | null

    readonly remoteOnly?: boolean | null

    readonly source?: string | null

    readonly unscoredOnly?: boolean | null
}

/**
 * Request parameters for externalJobApiPreviewExternalFetch operation in ExternalJobApiApi.
 */
export interface ExternalJobApiApiExternalJobApiPreviewExternalFetchRequest {
    readonly fetchRequestBody: FetchRequestBody
}

/**
 * Request parameters for externalJobApiReconcileThinExternalJobs operation in ExternalJobApiApi.
 */
export interface ExternalJobApiApiExternalJobApiReconcileThinExternalJobsRequest {
    readonly reconcileThinBody: ReconcileThinBody
}

/**
 * Request parameters for externalJobApiRescoreExternalCatalogRoute operation in ExternalJobApiApi.
 */
export interface ExternalJobApiApiExternalJobApiRescoreExternalCatalogRouteRequest {
    readonly rescoreCatalogBody: RescoreCatalogBody
}

/**
 * Request parameters for externalJobApiRunExternalFetch operation in ExternalJobApiApi.
 */
export interface ExternalJobApiApiExternalJobApiRunExternalFetchRequest {
    readonly fetchRequestBody: FetchRequestBody
}

/**
 * Request parameters for externalJobApiSetAtsBoardScores operation in ExternalJobApiApi.
 */
export interface ExternalJobApiApiExternalJobApiSetAtsBoardScoresRequest {
    readonly setATSBoardScoresBody: SetATSBoardScoresBody
}

/**
 * Request parameters for externalJobApiSweepExternalJobHygiene operation in ExternalJobApiApi.
 */
export interface ExternalJobApiApiExternalJobApiSweepExternalJobHygieneRequest {
    readonly hygieneSweepBody: HygieneSweepBody
}

/**
 * Request parameters for externalJobApiTargetedExternalIngest operation in ExternalJobApiApi.
 */
export interface ExternalJobApiApiExternalJobApiTargetedExternalIngestRequest {
    readonly targetedIngestBody: TargetedIngestBody
}

/**
 * Request parameters for externalJobApiUnblockExternalCompany operation in ExternalJobApiApi.
 */
export interface ExternalJobApiApiExternalJobApiUnblockExternalCompanyRequest {
    readonly blockId: string
}

/**
 * Request parameters for externalJobApiUpdateAtsBoard operation in ExternalJobApiApi.
 */
export interface ExternalJobApiApiExternalJobApiUpdateAtsBoardRequest {
    readonly boardId: string

    readonly updateATSBoardBody: UpdateATSBoardBody
}

/**
 * Request parameters for externalJobApiUpdateExternalJobPreference operation in ExternalJobApiApi.
 */
export interface ExternalJobApiApiExternalJobApiUpdateExternalJobPreferenceRequest {
    readonly updateExternalJobPreferenceBody: UpdateExternalJobPreferenceBody
}

/**
 * ExternalJobApiApi - object-oriented interface
 */
export class ExternalJobApiApi extends BaseAPI {
    /**
     * 
     * @param {ExternalJobApiApiExternalJobApiApplyClaudeReviewVerdictsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public externalJobApiApplyClaudeReviewVerdicts(requestParameters: ExternalJobApiApiExternalJobApiApplyClaudeReviewVerdictsRequest, options?: RawAxiosRequestConfig) {
        return ExternalJobApiApiFp(this.configuration).externalJobApiApplyClaudeReviewVerdicts(requestParameters.claudeReviewVerdictsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExternalJobApiApiExternalJobApiBackfillExternalJobLocationsRouteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public externalJobApiBackfillExternalJobLocationsRoute(requestParameters: ExternalJobApiApiExternalJobApiBackfillExternalJobLocationsRouteRequest, options?: RawAxiosRequestConfig) {
        return ExternalJobApiApiFp(this.configuration).externalJobApiBackfillExternalJobLocationsRoute(requestParameters.backfillLocationsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExternalJobApiApiExternalJobApiBlockExternalCompanyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public externalJobApiBlockExternalCompany(requestParameters: ExternalJobApiApiExternalJobApiBlockExternalCompanyRequest, options?: RawAxiosRequestConfig) {
        return ExternalJobApiApiFp(this.configuration).externalJobApiBlockExternalCompany(requestParameters.blockCompanyBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExternalJobApiApiExternalJobApiBulkCreateAtsBoardsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public externalJobApiBulkCreateAtsBoards(requestParameters: ExternalJobApiApiExternalJobApiBulkCreateAtsBoardsRequest, options?: RawAxiosRequestConfig) {
        return ExternalJobApiApiFp(this.configuration).externalJobApiBulkCreateAtsBoards(requestParameters.bulkCreateATSBoardsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExternalJobApiApiExternalJobApiCensusAllAtsBoardsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public externalJobApiCensusAllAtsBoards(requestParameters: ExternalJobApiApiExternalJobApiCensusAllAtsBoardsRequest = {}, options?: RawAxiosRequestConfig) {
        return ExternalJobApiApiFp(this.configuration).externalJobApiCensusAllAtsBoards(requestParameters.includeAll, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExternalJobApiApiExternalJobApiCensusAtsBoardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public externalJobApiCensusAtsBoard(requestParameters: ExternalJobApiApiExternalJobApiCensusAtsBoardRequest, options?: RawAxiosRequestConfig) {
        return ExternalJobApiApiFp(this.configuration).externalJobApiCensusAtsBoard(requestParameters.boardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExternalJobApiApiExternalJobApiCensusJobspipeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public externalJobApiCensusJobspipe(requestParameters: ExternalJobApiApiExternalJobApiCensusJobspipeRequest, options?: RawAxiosRequestConfig) {
        return ExternalJobApiApiFp(this.configuration).externalJobApiCensusJobspipe(requestParameters.jobsPipeCensusBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExternalJobApiApiExternalJobApiCreateAtsBoardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public externalJobApiCreateAtsBoard(requestParameters: ExternalJobApiApiExternalJobApiCreateAtsBoardRequest, options?: RawAxiosRequestConfig) {
        return ExternalJobApiApiFp(this.configuration).externalJobApiCreateAtsBoard(requestParameters.createATSBoardBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExternalJobApiApiExternalJobApiDeleteAtsBoardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public externalJobApiDeleteAtsBoard(requestParameters: ExternalJobApiApiExternalJobApiDeleteAtsBoardRequest, options?: RawAxiosRequestConfig) {
        return ExternalJobApiApiFp(this.configuration).externalJobApiDeleteAtsBoard(requestParameters.boardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExternalJobApiApiExternalJobApiFetchOneExternalJobRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public externalJobApiFetchOneExternalJob(requestParameters: ExternalJobApiApiExternalJobApiFetchOneExternalJobRequest, options?: RawAxiosRequestConfig) {
        return ExternalJobApiApiFp(this.configuration).externalJobApiFetchOneExternalJob(requestParameters.fetchCatalogItemBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExternalJobApiApiExternalJobApiFetchTopExternalJobsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public externalJobApiFetchTopExternalJobs(requestParameters: ExternalJobApiApiExternalJobApiFetchTopExternalJobsRequest, options?: RawAxiosRequestConfig) {
        return ExternalJobApiApiFp(this.configuration).externalJobApiFetchTopExternalJobs(requestParameters.fetchTopBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public externalJobApiGetExternalJobPreferences(options?: RawAxiosRequestConfig) {
        return ExternalJobApiApiFp(this.configuration).externalJobApiGetExternalJobPreferences(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExternalJobApiApiExternalJobApiIngestAtsBoardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public externalJobApiIngestAtsBoard(requestParameters: ExternalJobApiApiExternalJobApiIngestAtsBoardRequest, options?: RawAxiosRequestConfig) {
        return ExternalJobApiApiFp(this.configuration).externalJobApiIngestAtsBoard(requestParameters.boardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExternalJobApiApiExternalJobApiIngestExternalCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public externalJobApiIngestExternalCollection(requestParameters: ExternalJobApiApiExternalJobApiIngestExternalCollectionRequest, options?: RawAxiosRequestConfig) {
        return ExternalJobApiApiFp(this.configuration).externalJobApiIngestExternalCollection(requestParameters.ingestCollectionBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExternalJobApiApiExternalJobApiListAtsBoardsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public externalJobApiListAtsBoards(requestParameters: ExternalJobApiApiExternalJobApiListAtsBoardsRequest = {}, options?: RawAxiosRequestConfig) {
        return ExternalJobApiApiFp(this.configuration).externalJobApiListAtsBoards(requestParameters.category, requestParameters._function, requestParameters.hasIndia, requestParameters.hasIndiaRemote, requestParameters.hasRemote, requestParameters.isActive, requestParameters.limit, requestParameters.maxRelevance, requestParameters.minJobs, requestParameters.minRelevance, requestParameters.offset, requestParameters.q, requestParameters.seniority, requestParameters.source, requestParameters.tag, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExternalJobApiApiExternalJobApiListBlockedExternalCompaniesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public externalJobApiListBlockedExternalCompanies(requestParameters: ExternalJobApiApiExternalJobApiListBlockedExternalCompaniesRequest = {}, options?: RawAxiosRequestConfig) {
        return ExternalJobApiApiFp(this.configuration).externalJobApiListBlockedExternalCompanies(requestParameters.includeInactive, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExternalJobApiApiExternalJobApiListCatalogCountryFacetsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public externalJobApiListCatalogCountryFacets(requestParameters: ExternalJobApiApiExternalJobApiListCatalogCountryFacetsRequest = {}, options?: RawAxiosRequestConfig) {
        return ExternalJobApiApiFp(this.configuration).externalJobApiListCatalogCountryFacets(requestParameters.boardId, requestParameters.country, requestParameters._function, requestParameters.includeDuplicates, requestParameters.indiaOnly, requestParameters.minScore, requestParameters.page, requestParameters.pageSize, requestParameters.postedWithinDays, requestParameters.remoteOnly, requestParameters.search, requestParameters.seniority, requestParameters.source, requestParameters.unfetchedOnly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExternalJobApiApiExternalJobApiListCompanyBlockCandidatesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public externalJobApiListCompanyBlockCandidates(requestParameters: ExternalJobApiApiExternalJobApiListCompanyBlockCandidatesRequest = {}, options?: RawAxiosRequestConfig) {
        return ExternalJobApiApiFp(this.configuration).externalJobApiListCompanyBlockCandidates(requestParameters.minBlocks, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public externalJobApiListExternalCollections(options?: RawAxiosRequestConfig) {
        return ExternalJobApiApiFp(this.configuration).externalJobApiListExternalCollections(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExternalJobApiApiExternalJobApiListExternalFetchRunsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public externalJobApiListExternalFetchRuns(requestParameters: ExternalJobApiApiExternalJobApiListExternalFetchRunsRequest = {}, options?: RawAxiosRequestConfig) {
        return ExternalJobApiApiFp(this.configuration).externalJobApiListExternalFetchRuns(requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExternalJobApiApiExternalJobApiListExternalJobCatalogRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public externalJobApiListExternalJobCatalog(requestParameters: ExternalJobApiApiExternalJobApiListExternalJobCatalogRequest = {}, options?: RawAxiosRequestConfig) {
        return ExternalJobApiApiFp(this.configuration).externalJobApiListExternalJobCatalog(requestParameters.boardId, requestParameters.country, requestParameters._function, requestParameters.includeDuplicates, requestParameters.indiaOnly, requestParameters.minScore, requestParameters.page, requestParameters.pageSize, requestParameters.postedWithinDays, requestParameters.remoteOnly, requestParameters.search, requestParameters.seniority, requestParameters.source, requestParameters.unfetchedOnly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExternalJobApiApiExternalJobApiListExternalJobsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public externalJobApiListExternalJobs(requestParameters: ExternalJobApiApiExternalJobApiListExternalJobsRequest, options?: RawAxiosRequestConfig) {
        return ExternalJobApiApiFp(this.configuration).externalJobApiListExternalJobs(requestParameters.activeJobBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExternalJobApiApiExternalJobApiListJobsForClaudeReviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public externalJobApiListJobsForClaudeReview(requestParameters: ExternalJobApiApiExternalJobApiListJobsForClaudeReviewRequest = {}, options?: RawAxiosRequestConfig) {
        return ExternalJobApiApiFp(this.configuration).externalJobApiListJobsForClaudeReview(requestParameters.company, requestParameters.includeReviewed, requestParameters.limit, requestParameters.maxGrade, requestParameters.remoteOnly, requestParameters.source, requestParameters.unscoredOnly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public externalJobApiPreviewAutoPost(options?: RawAxiosRequestConfig) {
        return ExternalJobApiApiFp(this.configuration).externalJobApiPreviewAutoPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExternalJobApiApiExternalJobApiPreviewExternalFetchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public externalJobApiPreviewExternalFetch(requestParameters: ExternalJobApiApiExternalJobApiPreviewExternalFetchRequest, options?: RawAxiosRequestConfig) {
        return ExternalJobApiApiFp(this.configuration).externalJobApiPreviewExternalFetch(requestParameters.fetchRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExternalJobApiApiExternalJobApiReconcileThinExternalJobsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public externalJobApiReconcileThinExternalJobs(requestParameters: ExternalJobApiApiExternalJobApiReconcileThinExternalJobsRequest, options?: RawAxiosRequestConfig) {
        return ExternalJobApiApiFp(this.configuration).externalJobApiReconcileThinExternalJobs(requestParameters.reconcileThinBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExternalJobApiApiExternalJobApiRescoreExternalCatalogRouteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public externalJobApiRescoreExternalCatalogRoute(requestParameters: ExternalJobApiApiExternalJobApiRescoreExternalCatalogRouteRequest, options?: RawAxiosRequestConfig) {
        return ExternalJobApiApiFp(this.configuration).externalJobApiRescoreExternalCatalogRoute(requestParameters.rescoreCatalogBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExternalJobApiApiExternalJobApiRunExternalFetchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public externalJobApiRunExternalFetch(requestParameters: ExternalJobApiApiExternalJobApiRunExternalFetchRequest, options?: RawAxiosRequestConfig) {
        return ExternalJobApiApiFp(this.configuration).externalJobApiRunExternalFetch(requestParameters.fetchRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public externalJobApiSeedExternalCollections(options?: RawAxiosRequestConfig) {
        return ExternalJobApiApiFp(this.configuration).externalJobApiSeedExternalCollections(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExternalJobApiApiExternalJobApiSetAtsBoardScoresRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public externalJobApiSetAtsBoardScores(requestParameters: ExternalJobApiApiExternalJobApiSetAtsBoardScoresRequest, options?: RawAxiosRequestConfig) {
        return ExternalJobApiApiFp(this.configuration).externalJobApiSetAtsBoardScores(requestParameters.setATSBoardScoresBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExternalJobApiApiExternalJobApiSweepExternalJobHygieneRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public externalJobApiSweepExternalJobHygiene(requestParameters: ExternalJobApiApiExternalJobApiSweepExternalJobHygieneRequest, options?: RawAxiosRequestConfig) {
        return ExternalJobApiApiFp(this.configuration).externalJobApiSweepExternalJobHygiene(requestParameters.hygieneSweepBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExternalJobApiApiExternalJobApiTargetedExternalIngestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public externalJobApiTargetedExternalIngest(requestParameters: ExternalJobApiApiExternalJobApiTargetedExternalIngestRequest, options?: RawAxiosRequestConfig) {
        return ExternalJobApiApiFp(this.configuration).externalJobApiTargetedExternalIngest(requestParameters.targetedIngestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExternalJobApiApiExternalJobApiUnblockExternalCompanyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public externalJobApiUnblockExternalCompany(requestParameters: ExternalJobApiApiExternalJobApiUnblockExternalCompanyRequest, options?: RawAxiosRequestConfig) {
        return ExternalJobApiApiFp(this.configuration).externalJobApiUnblockExternalCompany(requestParameters.blockId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExternalJobApiApiExternalJobApiUpdateAtsBoardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public externalJobApiUpdateAtsBoard(requestParameters: ExternalJobApiApiExternalJobApiUpdateAtsBoardRequest, options?: RawAxiosRequestConfig) {
        return ExternalJobApiApiFp(this.configuration).externalJobApiUpdateAtsBoard(requestParameters.boardId, requestParameters.updateATSBoardBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExternalJobApiApiExternalJobApiUpdateExternalJobPreferenceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public externalJobApiUpdateExternalJobPreference(requestParameters: ExternalJobApiApiExternalJobApiUpdateExternalJobPreferenceRequest, options?: RawAxiosRequestConfig) {
        return ExternalJobApiApiFp(this.configuration).externalJobApiUpdateExternalJobPreference(requestParameters.updateExternalJobPreferenceBody, options).then((request) => request(this.axios, this.basePath));
    }
}

export const ExternalJobApiListAtsBoardsSourceEnum = {
    Greenhouse: 'Greenhouse',
    Lever: 'Lever',
    Ashby: 'Ashby',
    SmartRecruiters: 'SmartRecruiters',
    Workday: 'Workday',
    Eightfold: 'Eightfold',
    SuccessFactors: 'SuccessFactors',
} as const;
export type ExternalJobApiListAtsBoardsSourceEnum = typeof ExternalJobApiListAtsBoardsSourceEnum[keyof typeof ExternalJobApiListAtsBoardsSourceEnum];
